interface LosiIconProps {
  className?: string
}

export const LosiIcon = ({ className }: LosiIconProps) => (
  <svg
    width="48"
    height="48"
    viewBox="0 0 34 34"
    fill="none"
    className={className + ' drop-shadow-md'}
    xmlns="http://www.w3.org/2000/svg"
  >
    <ellipse
      cx="16.8819"
      cy="17.0198"
      rx="9.0539"
      ry="14.0748"
      transform="rotate(-44.3491 16.8819 17.0198)"
      stroke="currentColor"
      strokeWidth="1.5"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.1113 6.09863C26.2632 7.36269 26.3865 7.48397 27.6716 7.63346C26.3865 7.78313 26.2632 7.90442 26.1113 9.16847C25.9591 7.90442 25.8358 7.78313 24.5508 7.63346C25.8358 7.48397 25.9591 7.36269 26.1113 6.09863Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.7833 10.6805C17.4066 15.8655 17.9124 16.3631 23.1835 16.9762C17.9124 17.5902 17.4066 18.0877 16.7833 23.2727C16.1592 18.0877 15.6534 17.5902 10.3823 16.9762C15.6534 16.3631 16.1592 15.8655 16.7833 10.6805Z"
      fill="currentColor"
    />
  </svg>
)
